<template>
  <div class="container">
    <div class="chatbot-container">
      <iframe
        class="chatbot-frame"
        src="https://api.servebotai.com/chatbot/h8b36Er9qJhFjeiK"
        frameborder="0"
        allow="microphone"
      />

      <h3>
        テスト環境のため、ServeBotAIが24時間オンラインで対応するシナリオのすべての機能を表示することはできません。そのため、ServeBotAIと人間のカスタマーサポートが連携する能力をアイコン形式で表現します。
      </h3>

      <p>[🤷]ServeBotAIの知識が不足しているため、人間の介入が必要です。</p>
      <p>[👨‍🔧]ServeBotAIが人間のカスタマーサポートチームにメッセージを同期しており、訪問対応が必要な可能性があることを示します。</p>
      <p>[⚠️]ServeBotAIがクレームやお客様の不満に対応しており、人間のカスタマーサポートが介入して対応を引き継ぐ必要があることを示します。</p>
    </div>

    <!-- 右侧房间信息面板 -->
    <div class="room-info-panel">
      <h3>部屋の基本情報[ServeBotAIが部屋に関する詳細を学習しました]</h3>

      <div class="room-image">
        <img :src="room.image" alt="部屋の画像" />
      </div>

      <div class="room-details">
        <p><strong>部屋番号：</strong>{{ room.number }}</p>
        <p><strong>面積：</strong>{{ room.size }}平方メートル</p>
        <p><strong>ベッドタイプ：</strong>{{ room.beds }}</p>
        <p><strong>最大宿泊人数：</strong>{{ room.maxGuests }}人</p>
      </div>

      <!-- 設備 -->
      <section class="room-section">
        <h4>設備：</h4>
        <p v-if="!open.facilities">電子レンジ、冷蔵庫、エアコンなど、詳細な設備は展開してご覧ください。</p>
        <p v-else>電子レンジ、冷蔵庫、エアコン、洗濯機、ヘアドライヤー、電気ケトル、高速Wi-Fi、専用バスルーム（シャワーとバスタブ付き）、シャンプー、コンディショナー、ボディソープ（DOVEブランド）、タオル、バスタオル（各1人1枚）、非使い捨てスリッパ。</p>
        <button @click="toggle('facilities')">{{ open.facilities ? ' 内容を閉じる ' : ' 詳細を見る ' }}</button>
      </section>

      <!-- 位置 -->
      <section class="room-section">
        <h4>宿泊施設の住所：</h4>
        <p v-if="!open.location">宿泊施設名{{ room.apartmentName }}、詳細住所は展開してご覧ください。</p>
        <div v-else>
          <p>宿泊施設名{{ room.apartmentName }}。住所：東京都T区3丁目11号。郵便番号：110-0016。</p>
        </div>
        <button @click="toggle('location')">{{ open.location ? ' 内容を閉じる ' : ' 詳細を見る ' }}</button>
      </section>

      <!-- 周辺情報 -->
      <section class="room-section">
        <h4>周辺情報：</h4>
        <p v-if="!open.surroundings">アメ横、上野恩賜動物園など、詳細情報は展開してご覧ください。</p>
        <p v-else>商店街アメ横（徒歩10分）、上野恩賜動物園（徒歩19分）、不忍池（徒歩20分）。</p>
        <button @click="toggle('surroundings')">{{ open.surroundings ? ' 内容を閉じる ' : ' 詳細を見る ' }}</button>
      </section>

      <!-- ホストのおすすめ -->
      <section class="room-section">
        <h4>ホストのおすすめ：</h4>
        <p v-if="!open.recommendation">蒙古タンメン中本、大衆ジンギスカン、吉野家など、詳細なおすすめ情報は展開してご覧ください。</p>
        <p v-else>蒙古タンメン中本 御徒町店：おすすめは看板メニュー北極ラーメン。好みに応じて辛さを調整可能で、辛味が好きな方に最適です。（徒歩7分）。大衆ジンギスカン酒場ラムちゃん 御徒町店：おすすめは贅沢全フード食べ放題コース。無制限のジンギスカン食べ放題を提供。（徒歩7分）。吉野家 蔵前橋通鳥越店：朝食に最適で、おすすめは牛丼。味噌汁と野菜サラダ付き。（徒歩7分）。</p>
        <button @click="toggle('recommendation')">{{ open.recommendation ? ' 内容を閉じる ' : ' 詳細を見る ' }}</button>
      </section>

      <!-- キャンセルポリシー -->
      <section class="room-section">
        <h4>キャンセルポリシー：</h4>
        <p v-if="!open.refund">予約のキャンセルまたは変更については、詳細な規則を展開してご確認ください。</p>
        <p v-else>予約のキャンセルは予約プラットフォームの規則に従う必要があります。キャンセル可能な場合、プラットフォーム上でお客様自身で操作してください。宿泊日の変更もプラットフォームの規則に従い、具体的にはプラットフォームがサポートする機能に依存します。</p>
        <button @click="toggle('refund')">{{ open.refund ? ' 内容を閉じる ' : ' 詳細を見る ' }}</button>
      </section>
    </div>
  </div>
</template>

<script>
import { reactive } from 'vue'
import room702Image from '../assets/room702.png' // 导入图片

export default {
  name: 'Im',
  setup() {
    const room = reactive({
      image: room702Image, // 使用导入的图片
      number: '702',
      size: 32,
      beds: '1.4メートルのダブルベッド1台と2人用ソファベッド1台',
      maxGuests: 4,
      facilities: [
        '電子レンジ', '冷蔵庫', 'エアコン', '洗濯機', 'ヘアドライヤー', '電気ケトル',
        '高速Wi-Fi', '専用バスルーム（シャワーとバスタブ付き）',
        'シャンプー', 'コンディショナー', 'ボディソープ（DOVEブランド）',
        'タオル', 'バスタオル（各1人1枚）', '非使い捨てスリッパ'
      ],
      apartmentName: 'ServeBotAI Test Room',
      address: '東京都台東区上野 ○○‑○‑○（テスト用ダミー住所）',
      surroundings: ['アメ横（Ameya‑Yokochō）', '上野恩賜動物園', '上野公園', '上野駅（JR/地下鉄）'],
      recommendations: ['蒙古タンめン中本 上野店', '大衆ジンギスカン酒場', '吉野家 上野店'],
      refundPolicy: [
        'チェックイン7日前まで無料キャンセル可',
        '7日〜3日前：50%返金',
        '2日以内：返金不可',
      ],
    })

    const open = reactive({
      facilities: false,
      location: false,
      surroundings: false,
      recommendation: false,
      refund: false,
    })

    function toggle(key) {
      open[key] = !open[key]
    }

    return {
      room,
      open,
      toggle
    }
  }
}
</script>

<style scoped>
/* 全局字体设置 */
* {
  font-family: Arial, Meiryo, sans-serif;
}
h2,h3 {
  font-family: 'Hiragino Kaku Gothic Std', sans-serif;
}

/* 基础布局 */
.container {
    display: flex;
    flex-direction: row;
    gap: 20px;
    width: 100%;
    height: auto;
}

.chatbot-container {
  flex: 6;
  max-width: 60%;
  min-height: 700px;
  box-sizing: border-box;
}



.chatbot-frame {
    width: 100%;
    min-height: 700px;
    border: 1px solid #ddd;
    border-radius: 10px;
}

.room-info-panel {
    flex: 4;
    max-width: 40%;
    background-color: #fff;
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 10px;
    box-sizing: border-box;
}

.room-info-panel h3 {
  margin: 10px;
  font-size: 1.2em;
  color: #333;
}
.room-image img {
    width: 60%;
    height: 60%;
    border-radius: 10px;
    margin-bottom: 15px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, .1)
}

.room-details p {
    margin: 10px;
    font-size: 1em;
    line-height: 1.6;
    color: #000012;
}

.room-section h4 {
  margin: 10px;
  font-size: 1.2em;
  color: #333;
}

p {
  margin: 10px;
  font-size: 1em;
  line-height: 1.6;
  color: #000012;
}


.bulleted {
  padding-left: 18px;
  margin: 8px 0;
}

button {
    display: block;
    padding: 8px 15px;
    background-color: #004be4;
    color: #fff;
    border: none;
    border-radius: 5px;
    font-size: 1em;
    cursor: pointer;
    text-align: center;
    margin: 10px;
}

@media (max-width: 1000px) {
  .container {
    grid-template-columns: 1fr;
  }
  .chatbot-frame {
    height: 400px;
  }
}
</style>
